import React, { Component } from "react";
import { Icon } from "react-materialize";

import ConfigurationManager from "../../configuration/ConfigurationManager";

//import wbLogo from "./wb.svg";
// import wbLogo from "./White.png";
// import starlabsLogo from "./starlabs.svg";

import artAssetsImg from "./nav_artassets.png";
import auditImg from "./nav_audit.png";
import helpImg from "./nav_help.png";
import jobsImg from "./nav_jobs.png";
import searchImg from "./nav_search.png";
import submitJobImg from "./nav_submitjob.png";
import wbShieldImg from "./nav_wbshield.png";

import "./Header.css";

import { I18nContext } from "../../I18nProvider";

class Header extends Component {
  static contextType = I18nContext;

  constructor(props) {
    super(props);

    this.state = {
      showSubmitJobMenu: false,
      showHelpMenu: false,
    };
  }

  get showSubmitJobMenu() {
    return this.state.showSubmitJobMenu;
  }

  set showSubmitJobMenu(showSubmitJobMenu) {
    this.setState({ showSubmitJobMenu: showSubmitJobMenu });
  }

  get showHelpMenu() {
    return this.state.showHelpMenu;
  }

  set showHelpMenu(showHelpMenu) {
    this.setState({ showHelpMenu: showHelpMenu });
  }

  render() {
    const appText = this.context;
    const wbcpHost = ConfigurationManager.getProperty("WBCP_HOST");
    const wbcpPort = ConfigurationManager.getProperty("WBCP_PORT");
    const hrefLink = "#";
    const { currentUser } = this.props;
    const { showSubmitJobMenu, showHelpMenu } = this.state;

    let buttons = {
      submitJob: false,
      productJob: false,
      marketingJob: false,
      packagingJob: false,
      publishingJob: false,
      gteJob: false,
      jobsPage: false,
      assetSearch: false,
      legacySearch: false,
      helpMenu: true,
      licenseeHelp: false,
      publisherHelp: false,
      productionManagerHelp: false,
      baRepHelp: false,
    };

    let access = currentUser != null ? currentUser.properties.groups : [];

    if (access.includes("administrators")) {
      for (let key in buttons) {
        buttons[key] = true;
      }
    } else {
      if (access.includes("rle:licensee")) {
        const hasLobs = access.some((group) => group.substring(0, 3) === "lob");

        buttons.licenseeHelp = true;

        if (hasLobs) {
          if (access.includes("lob:gte")) {
            buttons.gteJob = true;
          }

          if (access.includes("lob:publishing")) {
            buttons.publishingJob = true;
            buttons.publisherHelp = true;
            buttons.productionManagerHelp = true;
          }

          if (
            access.includes("lob:fashionHome") ||
            access.includes("lob:toys")
          ) {
            buttons.productJob = true;
            buttons.marketingJob = true;
            buttons.packagingJob = true;
          }

          buttons.submitJob = true;
          buttons.jobsPage = true;
        }
      }

      if (
        access.includes("rle:licensee") ||
        access.includes("rle:licenseeDesigner") ||
        access.includes("rle:wbcpCreative")
      ) {
        buttons.assetSearch = true;
      }

      if (access.includes("rle:wbcpCreative")) {
        buttons.baRepHelp = true;
      }

      if (access.includes("rle:wbcpLegacy")) {
        buttons.legacySearch = true;
      }
    }

    return (
      <header id="navbar" className="navbar">
        <div className="navbar-container">
          <div className="navbar-logo">
            <a href={`${wbcpHost}:${wbcpPort}`} target="_self">
              <img src={wbShieldImg} alt="" />
              <h1>STAR LABS</h1>
            </a>
          </div>
          <ul className="nav-links">
            <li
              id="SubmitJob"
              hidden={!buttons.submitJob}
              onMouseOver={() => (this.showSubmitJobMenu = true)}
              onMouseLeave={() => (this.showSubmitJobMenu = false)}
            >
              <a href={hrefLink} style={{ margin: "0", userSelect: "none" }}>
                <img src={submitJobImg} />
                <span>{appText.T1}</span>
              </a>
              <div
                hidden={!showSubmitJobMenu}
                id="SubmitJobMenu"
                className="submit-job-menu"
              >
                <a
                  id="productPage"
                  href={`${wbcpHost}:${wbcpPort}/submit/product/`}
                  style={!buttons.productJob ? { display: "none" } : {}}
                >
                  {/* Product */}
                  {appText.T7}
                </a>
                <a
                  id="packagingPage"
                  href={`${wbcpHost}:${wbcpPort}/submit/packaging/`}
                  style={!buttons.packagingJob ? { display: "none" } : {}}
                >
                  {/* Packaging */}
                  {appText.T8}
                </a>
                <a
                  id="marketingPage"
                  href={`${wbcpHost}:${wbcpPort}/submit/marketing/`}
                  style={!buttons.marketingJob ? { display: "none" } : {}}
                >
                  {appText.T9}
                </a>
                <a
                  id="publishingPage"
                  href={`${wbcpHost}:${wbcpPort}/submit/publishing/`}
                  style={!buttons.publishingJob ? { display: "none" } : {}}
                >
                  {appText.T10}
                </a>
                <a
                  id="gtePage"
                  href={`${wbcpHost}:${wbcpPort}/submit/gte/`}
                  style={!buttons.gteJob ? { display: "none" } : {}}
                >
                  {/* Themed Entertainment */}
                  {appText.T11}
                </a>
              </div>
            </li>
            <li id="JobsPage" hidden={!buttons.jobsPage}>
              <a href={`${wbcpHost}:${wbcpPort}/#!/jobs`}>
                <img src={jobsImg} />
                <span>{appText.T2}</span>
              </a>
            </li>
            <li hidden={!buttons.assetSearch}>
              <a href={`${wbcpHost}:${wbcpPort}/#!/search`}>
                <img src={artAssetsImg} />
                <span>{appText.T3}</span>
              </a>
            </li>
            <li id="LegacySearch" hidden={!buttons.legacySearch}>
              <a href={`${wbcpHost}:${wbcpPort}/LegacySearch/`}>
                <img src={searchImg} />
                <span>{appText.T4}</span>
              </a>
            </li>
            <li id="AuditReport" hidden={!buttons.legacySearch}>
              <a href={`${wbcpHost}:${wbcpPort}/AuditReport/`}>
                <img src={auditImg} />
                <span>{appText.T5}</span>
              </a>
            </li>
            <li
              id="HelpMenu"
              hidden={!buttons.helpMenu}
              onMouseOver={() => (this.showHelpMenu = true)}
              onMouseLeave={() => (this.showHelpMenu = false)}
            >
              <img src={helpImg} alt="" />
              <div
                id="HelpDropMenu"
                className="help-menu"
                hidden={!showHelpMenu}
              >
                <a
                  id="licenseeHelp"
                  href={`${wbcpHost}:${wbcpPort}/#!/help/licensee`}
                  style={!buttons.licenseeHelp ? { display: "none" } : {}}
                >
                  {appText.T12}
                </a>
                <a
                  id="publisherHelp"
                  href={`${wbcpHost}:${wbcpPort}/#!/help/publisher`}
                  style={!buttons.publisherHelp ? { display: "none" } : {}}
                >
                  {appText.T13}
                </a>
                <a
                  id="productionManagerHelp"
                  href={`${wbcpHost}:${wbcpPort}/#!/help/productionmanager`}
                  style={
                    !buttons.productionManagerHelp ? { display: "none" } : {}
                  }
                >
                  {/* Production Manager Help */}
                  {appText.T14}
                </a>
                <a
                  id="barepHelp"
                  href={`${wbcpHost}:${wbcpPort}/#!/help/barep`}
                  style={!buttons.baRepHelp ? { display: "none" } : {}}
                >
                  {/* PD / BA Help */}
                  {appText.T15}
                </a>
                <a
                  id="starlabsSupport"
                  href="mailto:starlabs.support@warnerbros.com"
                >
                  {/* Email Support */}
                  {appText.T16}
                </a>
              </div>
            </li>
          </ul>
          <div className="burger">
            <div className="line1" />
            <div className="line2" />
            <div className="line3" />
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
